const pricing = {
  pricing: {
    pageTitle: 'Pricing',
    pageDescription: 'IOPS SPACE Ground Station only pays for the antenna time used. Contact us for more information.',
    plans: {
      pass: {
        title: 'PASS plan',
        price: '$2.5/min',
        description: 'Pay the usage fee in time for PASS to communicate with the ground station according to the orbit of the satellite!'
      },
      rental: {
        title: 'Rental plan',
        price: 'Coming Soon',
        description: 'Rent the entire ground station (S/W and H/W for communication) for a unit time and use it as much as you want!'
      },
      custom: {
        title: 'Custom plan',
        price: 'Customized',
        description: 'Create your own service and discuss it with a satellite operations expert!'
      }
    }
  }
};

export default pricing;
